import { Stack, styled } from '@mui/material';
import { mentionChipStyles } from 'src/components/TextWithUI/mentions/use-text-with-ui-mentions';

export const EditorContainer = styled(Stack, {
  name: 'EditorContainer',
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  height: '100%',

  '& [draggable="true"]:has(img[draggable="true"])': {
    marginBlock: theme.spacing(1),
  },

  '& .editor-content': {
    display: 'flex',
    flex: 1,
    /* Same size as the sent-message bubble so a draft reads the way it will land in the thread. */
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: 1.5,
    minHeight: 0,

    '& p': {
      margin: theme.spacing(0),
    },

    ...mentionChipStyles(theme),

    '> .portal-editor': {
      flexGrow: 1,
    },
  },

  '&:has(.portal-editor.ProseMirror-focused.ProseMirror-hideselection) [data-tippy-root]': {
    display: 'none',
  },

  '& .portal-editor': {
    maxHeight: '25rem',
    overflow: 'auto',

    '--blockquote-border-color': theme.palette.custom.OV.sys.surfaceVariant,
    '--blockquote-background-color': theme.palette.custom.OV.sys.surface,

    '--placeholder-color': theme.palette.custom.OV.sys.outline,
    ...(error ? { '--placeholder-error-color': theme.palette.error.main } : {}),
  },
  '& .portal-editor:focus-visible': {
    outline: 'none',
  },
  '& .portal-editor code': {
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHighest,
    borderRadius: '0.25rem',
    boxDecorationBreak: 'clone',
    color: theme.palette.custom.OV.sys.onSurface,
    fontSize: '0.9rem',
    padding: '0.25rem',
  },
  '& .portal-editor img': {
    maxWidth: '90%',
    borderRadius: theme.shape.borderRadius,
  },
}));
